export default {
  "pendingReview": "Pending review",
  "approved": "Approved",
  "rejected": "Rejected",
  "couldNotLoadMembershipApplications": "Could not load membership applications",
  "couldNotLoadApplicationDetails": "Could not load application details",
  "approve": "Approve",
  "reject": "Reject",
  "membershipApplications": "Membership applications",
  "applicationDeleteConfirm": "Delete this application? Existing membership and fee records will be kept.",
  "applicationDeleted": "Membership application deleted",
  "applicationDeleteFailed": "Could not delete the membership application",
  "membershipApplications1": "💡 Membership applications",
  "doNotIncurFees": "do not incur fees",
  "paymentMethodsAndStatusesAreTherefore": ". Payment methods and statuses are therefore not shown here. After approval and enrollment, bills are generated using Fee settings (see Renewal management). Each application records the",
  "applicationTerm": "Application term",
  "forArchivingAndReportingByTerm": "for archiving and reporting by term.",
  "switchTabsToViewApplicationsBy": "Switch tabs to view applications by member type",
  "all": "All",
  "searchRegistrationDetails": "Search registration details",
  "search": "Search",
  "status": "Status",
  "reviewer": "Reviewer",
  "appliedAt": "Applied at",
  "actions": "Actions",
  "viewDetails": "View details",
  "membershipApplicationDetails": "Membership application details",
  "reviewStatus": "Review status",
  "close": "Close",
  "paid": "Paid",
  "pendingPayment": "Pending payment",
  "overdue": "Overdue",
  "name": "Name",
  "enterAName": "Enter a name",
  "avatar": "Avatar",
  "phoneNumber": "Phone number",
  "enterAContactNumber": "Enter a contact number",
  "level": "Level",
  "couldNotLoadData": "Could not load data",
  "uploadAJPGPNGOrWEBP": "Upload a JPG, PNG or WEBP image up to 10 MB",
  "imageUploaded": "Image uploaded",
  "couldNotUploadImage": "Could not upload image",
  "selectAMemberType": "Select a member type",
  "couldNotDownloadTemplate": "Could not download template",
  "membersCsv": "members.csv",
  "couldNotExportData": "Could not export data",
  "selectAMemberTypeFirst": "Select a member type first",
  "uploadAnXlsxOrXlsFile": "Upload an .xlsx or .xls file",
  "couldNotReadTemplate": "Could not read template",
  "selectAFileToImport": "Select a file to import",
  "couldNotImportMembers": "Could not import members",
  "enterANameAndPhoneNumber": "Enter a name and phone number",
  "saved": "Saved",
  "couldNotSaveChanges": "Could not save changes",
  "deleteTheSelectedMembers": "Delete the selected members?",
  "delete": "Delete",
  "couldNotDelete": "Could not delete",
  "memberList": "Member list",
  "importInstructions": "⚠️ Import instructions:",
  "1UseTheQuickImportTemplate": "1. Use the quick import template to import members.",
  "downloadQuickImportTemplate": "Download quick import template",
  "toImportMembers": "to import members",
  "addMember": "+ Add member",
  "refresh": "Refresh",
  "edit": "Edit",
  "exportMembers": "Export members",
  "downloadQuickImportTemplate2": "Download quick import template",
  "importMembers": "Import members",
  "paymentStatus": "Payment status",
  "type": "Type",
  "organizationName": "Organization name",
  "positionLevel": "Position / level",
  "placeOfOrigin": "Place of origin",
  "industry": "Industry",
  "term": "Term",
  "joinedIn": "Joined in",
  "joinedOn": "Joined on",
  "expiresOn": "Expires on",
  "paymentMethods": "Payment methods",
  "active": "Active",
  "hidden": "Hidden",
  "addedAt": "Added at",
  "editMember": "Edit member",
  "addMember3": "Add member",
  "linkedWeChatUser": "Linked WeChat user",
  "selectARegisteredWeChatUserWho": "Select a registered WeChat user who is not yet a member",
  "memberType": "Member type",
  "visible": "Visible",
  "pleaseSelect": "Please select",
  "uploading": "Uploading…",
  "cancel": "Cancel",
  "save": "Save",
  "downloadTemplate": "Download template",
  "importFile": "Import file",
  "uploadExcelTemplate": "Upload Excel template",
  "useTheDownloadedXlsxTemplatePhone": "Use the downloaded .xlsx template. Phone numbers are read as text and used to match WeChat users and member profiles.",
  "confirmImport": "Confirm import",
  "memberShowcaseSettingsSaved": "Member showcase settings saved",
  "memberShowcase": "Member showcase",
  "viewMemberList": "View member list",
  "memberShowcaseIsTheMiniProgram": "Member showcase is the mini-program directory (member list and details). Configure visibility here. For fees and terms, see",
  "feeSettings": "Fee settings",
  "forPaymentChannelsAndBankAccounts": "; for payment channels and bank accounts, see",
  "configureDirectoryAccessMemberDetailVisibility": "Configure directory access, member detail visibility and sorting. Click Save settings to apply changes to the mini-program.",
  "publicDirectoryAccess": "Public directory access",
  "yes": "Yes",
  "no": "No",
  "whenEnabledEveryoneCanViewThis": "When enabled, everyone can view this organization's directory",
  "memberDetailAccess": "Member detail access",
  "partiallyPublic": "Partially public",
  "fullyPublic": "Fully public",
  "membersOnly": "Members only",
  "partiallyPublicEveryoneCanViewThe": "Partially public: everyone can view the list; only enrolled members can view details.",
  "fullyPublicEveryoneCanViewThe": "Fully public: everyone can view the list and details.",
  "membersOnlyOnlyEnrolledMembersCan": "Members only: only enrolled members can view the list and details.",
  "directorySorting": "Directory sorting",
  "byPinyin": "By pinyin",
  "byDistrict": "By district",
  "byPosition": "By position",
  "saveSettings": "Save settings",
  "onlinePaymentsEnabled": "Online payments enabled",
  "onlinePaymentsDisabled": "Online payments disabled",
  "couldNotUpdateSettings": "Could not update settings",
  "alipayWillBeAvailableWhenPayment": "Alipay will be available when payment configuration is supported",
  "couldNotUpdatePaymentChannel": "Could not update payment channel",
  "enterTheAccountHolderBankAnd": "Enter the account holder, bank and account number before enabling offline payments",
  "offlinePaymentsEnabled": "Offline payments enabled",
  "offlinePaymentsDisabled": "Offline payments disabled",
  "couldNotSaveBankAccount": "Could not save bank account",
  "bankAccountCopied": "Bank account copied",
  "couldNotCopyCopyTheDetails": "Could not copy. Copy the details manually.",
  "viewPaymentRecords": "View payment records",
  "chooseThePaymentMethodsAvailableTo": "Choose the payment methods available to members in the mini-program. Both methods can be enabled; disabled methods are hidden. Offline payments require a bank account and transfer receipt, which an administrator reviews before recording payment. Changes take effect immediately.",
  "onlinePayments": "Online payments",
  "enabled": "Enabled",
  "membersPayDirectlyInTheMini": "Members pay directly in the mini-program. Successful payments are recorded automatically.",
  "paymentChannels": "Payment channels",
  "weChatPay": "WeChat Pay",
  "alipay": "Alipay",
  "onlinePaymentsRequireAnActiveMerchant": "Online payments require an active merchant account under Mini-program settings → Payment settings. The payment entry is hidden until configured.",
  "configurePayments": "Configure payments",
  "offlinePayments": "Offline payments",
  "membersTransferFeesToABank": "Members transfer fees to a bank account and upload a receipt. Administrators confirm receipt before recording payment.",
  "bankTransferAccount": "Bank transfer account",
  "copyBankAccount": "Copy bank account",
  "accountHolder": "Account holder",
  "enterTheAccountHolder": "Enter the account holder",
  "bankIncludingBranch": "Bank (including branch)",
  "enterTheBankName": "Enter the bank name",
  "accountNumber": "Account number",
  "enterTheAccountNumber": "Enter the account number",
  "transferReference": "Transfer reference",
  "eGMembershipFeeMemberName": "e.g. Membership fee + member name",
  "memberInstructionsTransferFundsToThis": "Member instructions: transfer funds to this account and upload a receipt. Payment is recorded after administrator confirmation.",
  "thisMethodIsDisabledAccountDetails": "This method is disabled. Account details are hidden from members.",
  "paid4": "Paid",
  "refunded": "Refunded",
  "rejected5": "Rejected",
  "unpaid": "Unpaid",
  "bankTransfer": "Bank transfer",
  "confirmReceipt": "Confirm receipt",
  "confirmApproval": "Confirm approval",
  "paymentReceiptConfirmed": "Payment receipt confirmed",
  "actionFailed": "Action failed",
  "provideARejectionReasonTheMember": "Provide a rejection reason. The member can upload another receipt.",
  "rejectOfflinePayment": "Reject offline payment",
  "confirmRejection": "Confirm rejection",
  "eGUnclearReceiptIncorrectAmount": "e.g. Unclear receipt / incorrect amount / transfer not received",
  "enterARejectionReason": "Enter a rejection reason",
  "paymentRecordsCsv": "payment-records.csv",
  "paymentRecords": "Payment records",
  "export": "Export",
  "totalCollected": "Total collected",
  "paymentsRecorded": "payments recorded",
  "outstandingAmount": "Outstanding amount",
  "membersAwaitingPayment": "members awaiting payment",
  "refundCount": "Refund count",
  "totalRecords": "Total records",
  "paymentRecords6": "payment records",
  "searchOrderNumberNicknameName": "Search order number / nickname / name",
  "allLevels": "All levels",
  "allStatuses": "All statuses",
  "allPaymentMethods": "All payment methods",
  "thisYear": "This year",
  "allYears": "All years",
  "noPaymentRecords": "No payment records",
  "orderNumber": "Order number",
  "nickname": "Nickname",
  "membershipLevel": "Membership level",
  "membershipFee": "Membership fee",
  "paymentStatus7": "Payment status",
  "paidAt": "Paid at",
  "paymentReceipt": "Payment receipt",
  "view": "View",
  "createdAt": "Created at",
  "total": "Total",
  "recordsPaid": "records · Paid",
  "unpaid8": "· Unpaid",
  "rejected9": "· Rejected",
  "refunded10": "· Refunded",
  "payments": "payments",
  "noReceiptImage": "No receipt image",
  "enterAMemberType": "Enter a member type",
  "couldNotLoadMemberTypes": "Could not load member types",
  "memberTypeUpdated": "Member type updated",
  "memberTypeAdded": "Member type added",
  "couldNotSaveMemberType": "Could not save member type",
  "deleteMemberType": "Delete member type",
  "memberTypeDeleted": "Member type deleted",
  "couldNotDeleteMemberType": "Could not delete member type",
  "types": "types",
  "addMemberType": "+ Add member type",
  "applicantsChooseAMemberTypeAnd": "Applicants choose a member type and complete its registration form. Add, edit or delete types and configure fields here. Manage multipliers under Fee settings → Member type rates.",
  "registrationFields": "Registration fields",
  "couldNotLoadFieldsReopenThe": "Could not load fields. Reopen the configuration.",
  "fieldsIncluding": "fields, including",
  "requiredIndicatesRequired": "required · * indicates required",
  "configureRegistrationFields": "Configure registration fields",
  "noMemberTypesYetAddOne": "No member types yet. Add one.",
  "editMemberType": "Edit member type",
  "addMemberType11": "Add member type",
  "eGCorporateMember": "e.g. Corporate member",
  "description": "Description",
  "memberTypeDescription": "Member type description",
  "newTypesHaveADefaultMultiplier": "New types have a default multiplier of 1. Adjust multipliers in Fee settings.",
  "text": "Text",
  "shortTextSuchAsNamesTitles": "Short text such as names, titles and phone numbers",
  "multilineText": "Multiline text",
  "longTextSuchAsIntroductionsAnd": "Long text such as introductions and descriptions",
  "number": "Number",
  "numericValuesSuchAsQuantities": "Numeric values such as quantities",
  "date": "Date",
  "selectADate": "Select a date",
  "singleChoice": "Single choice",
  "selectOneOption": "Select one option",
  "multipleChoice": "Multiple choice",
  "selectMultipleOptions": "Select multiple options",
  "dropdown": "Dropdown",
  "selectFromADropdown": "Select from a dropdown",
  "imageUpload": "Image upload",
  "uploadAvatarsLogosAndOtherImages": "Upload avatars, logos and other images",
  "time": "Time",
  "selectATime": "Select a time",
  "dateAndTime": "Date and time",
  "selectADateAndTime": "Select a date and time",
  "basicFields": "Basic fields",
  "commonFields": "Common fields",
  "introduction": "Introduction",
  "address": "Address",
  "position": "Position",
  "advancedFields": "Advanced fields",
  "option1": "Option 1",
  "option2": "Option 2",
  "image": "Image",
  "couldNotLoadRegistrationFields": "Could not load registration fields",
  "upTo100FieldsAreAllowed": "Up to 100 fields are allowed",
  "option1Option2": "Option 1,Option 2",
  "enterAMemberTypeName": "Enter a member type name",
  "enterAFieldLabel": "Enter a field label",
  "memberTypeAndRegistrationFieldsAdded": "Member type and registration fields added",
  "registrationFieldSettingsSaved": "Registration field settings saved",
  "couldNotSaveRegistrationFields": "Could not save registration fields",
  "memberTypeName": "Member type name",
  "eGCouncilOrganizationMember": "e.g. Council organization member",
  "newTypesAlsoAppearUnderFee": "New types also appear under Fee settings → Member type rates. Adjust multipliers and descriptions there.",
  "fieldsMarkedAreRequiredSeparateOptions": "Fields marked * are required. Separate options for choice and dropdown fields with commas.",
  "registrationInformation": "Registration information",
  "configureTheFieldsMembersCompleteDuring": "Configure the fields members complete during enrollment. Add fields from the left palette, then select a field to edit its label, type and visibility on the right.",
  "dragToReorder": "Drag to reorder",
  "untitledField": "Untitled field",
  "hiddenOnEnrollment": "Hidden on enrollment",
  "moveFieldUp": "Move field up",
  "moveFieldDown": "Move field down",
  "duplicateField": "Duplicate field",
  "deleteField": "Delete field",
  "fromPositionsAndBaseAnnualFees": "From Positions and base annual fees",
  "addField": "+ Add field",
  "fieldProperties": "Field properties",
  "fieldLabel": "Field label",
  "nameShownOnTheMembershipRegistration": "Name shown on the membership registration form",
  "fieldType": "Field type",
  "required": "Required",
  "aRedMarksThisFieldAs": "A red * marks this field as required before submission",
  "showOnEnrollment": "Show on enrollment",
  "whenDisabledThisFieldIsHidden": "When disabled, this field is hidden on the enrollment form",
  "showInDetails": "Show in details",
  "whenDisabledThisFieldIsHidden12": "When disabled, this field is hidden in member details",
  "placeholderOptions": "Placeholder / options",
  "separateOptionsWithCommas": "Separate options with commas",
  "placeholder": "Placeholder",
  "optionsFollowThePositionAndBase": "Options follow the position and base annual fee settings",
  "grayPlaceholderTextForChoiceAnd": "Gray placeholder text. For choice and dropdown fields, enter comma-separated options.",
  "thisSystemFieldIsMandatoryIt": "This system field is mandatory. It cannot be deleted or made optional.",
  "thisSystemFieldCannotBeDeleted": "This system field cannot be deleted, renamed or retyped. Required and detail visibility settings can be adjusted.",
  "addAFieldFromTheLeft": "Add a field from the left palette,",
  "orSelectAFieldInThe": "or select a field in the preview",
  "toEditItsLabelTypeAnd": "to edit its label, type and visibility here.",
  "enabled13": "Enabled:",
  "disabled": "Disabled",
  "showAndEnable": "Show and enable",
  "newMemberType": "new member type",
  "message1": "Confirm {p0} for this application? This updates the application status only.",
  "message2": "{p0} application",
  "message3": "Application review completed: {p0}",
  "message4": "{p0} failed",
  "message5": "Parsed {p0} member records",
  "message6": "Import complete: {p0} added, {p1} updated",
  "message7": "Upload {p0}",
  "message8": "Account holder: {p0}",
  "message9": "Bank: {p0}",
  "message10": "Account number: {p0}",
  "message11": "Transfer reference: {p0}",
  "message12": "Confirm receipt of the bank transfer from “{p0}”? Approval marks the order paid and activates membership.",
  "message13": "Delete “{p0}” and its registration fields?",
  "message14": "Upload {p0}",
  "message15": "Select {p0}",
  "message16": "Enter {p0}",
  "message17": "{p0} (copy)",
  "message18": "Registration fields · {p0}",
  "message19": "{p0} information",
  "currentTerm": "Current term",
  "joinedTerm": "Enrollment term",
  "profileData": "Profile data",
  "feeCny": "Membership fee (CNY)",
  "hasReceipt": "Has receipt",
  "online": "Online",
  "offline": "Offline",
  "free": "Free",
  "templateSheet": "Member import",
  "templateFilename": "member-import.xlsx",
  "emptyImport": "No data to import",
  "phoneColumnRequired": "The template must contain a Phone number column",
  "missingPhone": "Phone number missing on row {row}",
  "approvedSuccess": "Application approved",
  "rejectedSuccess": "Application rejected",
  "applicationHint": "💡 Applications do not incur fees. After approval and enrollment, bills are generated using Fee settings (see Renewal management). Each application records its enrollment term for archiving and reporting.",
  "paymentSummary": "{total} records · Paid {paid} · Unpaid {unpaid} · Rejected {rejected} · Refunded {refunded}",
  "paymentOff": "Disabled",
  "sentenceEnd": "."
}
